import React, { useEffect, useState } from 'react'
import { AutoCompleteField } from 'components/QuestionnaireRequestAutomated/Requester/Components/autoCompleteField'
import ProcessorModal from '.'

const CANCELLATION_REASON = [
  { id: '1', name: 'deal fell through' },
  { id: '2', name: 'wrong address chosen' },
  { id: '3', name: 'wrong questionnaire type chosen' },
  { id: '4', name: 'wrong form chosen' },
  { id: '5', name: 'requester did not pay' },
  { id: '6', name: 'we no longer manage this building' },
  { id: '7', name: 'other' },
]

export default function CancelRequestModal({ open = false, onClose = () => {}, onSubmit = () => {} }) {
  const [cancelReasonValue, setCancelReasonValue] = useState('')

  useEffect(() => {
    setCancelReasonValue('')
  }, [open])

  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6 }}>
        <div className="dome-d-flex dome-flex-column dome-gap24">
          <div className="dome-d-flex dome-flex-column dome-gap12">
            <span>
              <i style={{ fontSize: '50px' }} className="fa-thin fa-circle-exclamation dome-color-red-alert"></i>
            </span>
            <span className="dome-h2 dome-color-red-alert">cancel request</span>
          </div>
          <div className="dome-d-flex dome-flex-column dome-gap12">
            <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap24">
              <span className="dome-p2 dome-color-darkest-grey">
                Selecting “Cancel Request” will notify the requesting party. They will need to re-submit a request for a
                questionnaire.
              </span>
              <span className="dome-p2 dome-color-darkest-grey">Are you sure you want to cancel this request?</span>
            </div>
          </div>
          <div className="dome-d-flex dome-justify-between">
            <button
              type="button"
              onClick={onClose}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
            >
              back
            </button>
            <button type="button" onClick={onSubmit} className="dome-btn dome-btn-base dome-btn-red-stroke">
              cancel request
            </button>
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
